define('controllers/modules/calendar/abstract-item',[
    // libs
    'underscore', 'backbone', 'moment',
    // parent
    'src/controller/controller'
], function(_, Backbone, moment, Controller) {

    var AbstractCalendarItemCtrl = Controller.extend({
        authDefault: true,
        routes: {
            '*new': 'newRoute',
            ':itemId(/)': 'editRoute',
            ':itemId/feedback(/)': 'feedbackRoute',
        },

        lazyInit: _.noop,

        _editRoute: function() {
            var view = this.getView();
            view.showDetails();
            this.getLayout().getContent()
                .setInfoContent(view, { open: true });
        },

        initialize: function(prefix, opt) {
            this.role = opt.role;
        },

        ////////////
        // routes //
        ////////////
        newRoute: function(groupId, userId, dayId) {
            var content = this.lazyInit().getContent(),
                date = moment(dayId),
                view = this.getView();

            return this.when([
                content.toggleInfoOverlay(false),
                this.profile.fetch()
            ].concat(this.onFetch())).then(function() {
                this.model.resetToNew(userId === "me" ? this.profile.id : userId, date);
                view.showDetails();
                content.setInfoContent(view, { open: true });
            });

        },

        editRoute: function(groupId, userId, conversationId, dayId, itemId) {
            var isConversationUrl = Backbone.history.getFragment().indexOf('messages') > -1;
            if (!isConversationUrl) {
                itemId = dayId;
                dayId = conversationId;
            }

            var content = this.lazyInit().getContent(),
                date = moment(dayId);

            if (this.model.id === itemId && date.isSame(this.model.get('date'), 'day')) {
                this._editRoute();
                return this.when();
            }

            this.model.resetToId(itemId, userId, { silent: true });

            return this.when([
                this.model.fetch({ force: true }),
                content.toggleInfoOverlay(false)
            ].concat(this.onFetch())).then(this._editRoute);
        },

        feedbackRoute: function(groupId, userId, dayId, itemId) {
            return this[itemId ? 'editRoute' : 'newRoute']
                .call(this, groupId, userId, dayId, itemId)
                .then(this.onFeedbackAction.bind(this));
        },

        getView: function() {
            var view = this.view;
            if (view.hasOwnProperty('supervisor') || view.hasOwnProperty('client')) {
                view = view[this.role];
            }
            return view;
        },

        isSupervisor: function() {
            return this.role === 'supervisor';
        },

        ////////////
        // events //
        ////////////
        onFetch: _.noop,
        onFeedbackAction: function() {
            this.getView().showFeedback();
        },

        onBack: function() {
            this.trigger('back');
        },

        onLayoutCreation: function(layout) {
            this.profile = layout.getMember();
            this.group = layout.getGroup();
        },

    });

    return AbstractCalendarItemCtrl;

});

